import UploadLogs from './UploadLogs'

export default UploadLogs



// WEBPACK FOOTER //
// ./src/components/UploadLogs/index.js